import React from 'react';
import FavoriteTab from '@/components/favorites/FavoriteTab';
import useFetchFavorite from '@/hooks/useFetchFavorite';

const FavoriteTabContainer = () => {
  const [menuFavoriteList, ideaFavoriteList, shoppingFavoriteList, isLoading] = useFetchFavorite();
  return (
    <FavoriteTab
      menuList={menuFavoriteList}
      ideaList={ideaFavoriteList}
      shoppingList={shoppingFavoriteList}
      isLoading={isLoading}
    />
  );
};

export default FavoriteTabContainer;
